module.exports = __webpack_public_path__ + "static/media/bytt-nn-13.e981a638.mp3";